import { queryKeys } from '@query/keys'
import { PaginatedQueryResult, usePaginatedQuery } from '@query/usePaginatedQuery'
import { useMemo, useState } from 'react'

import { useAccountReadContext } from '@context/AccountContextContext'
import { useSessionLanguage } from '@context/SessionSettingsContext'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { FilterQueryProps } from '@model/FilterFields'
import { NameDto } from '@model/NameDto'
import { TradingAccountRebateDetailedDto } from '@model/TradingAccountRebateDetailedDto'

interface IBTradingAccountsRebateSearch {
  tradingAccountOptions: NameDto<string>[]
  query: PaginatedQueryResult<TradingAccountRebateDetailedDto>
  search?: FilterQueryProps
  setSearch: (search: FilterQueryProps) => void
  clearSearch: (callback: () => void) => void
}

export const useIBTradingAccountsRebateSearch = (): IBTradingAccountsRebateSearch => {
  const apiClient = useApiClient(ClientApiClient)
  const locale = useSessionLanguage()
  const { account } = useAccountReadContext()

  const [search, setSearch] = useState<FilterQueryProps>()

  const ibId = account?.clientIntroducingBroker?.id

  const query = usePaginatedQuery({
    queryKey: queryKeys.ib.rebates.tradingAccountsSearch(ibId, { search, locale } as any),
    queryFn: (pageQuery) =>
      apiClient.getIBTradingAccountsRebate(ibId ?? '', {
        ...pageQuery,
        pageIndex: 0,
        pageSize: 25,
        search,
        caller: 'ca',
        languageId: locale,
      }),
  })

  const tradingAccountOptions = useMemo(() => {
    return query.data?.map((item) => item.tradingAccount) || []
  }, [query.data])

  const clearSearch = (callback: () => void) => {
    callback()
    setSearch({})
  }

  return {
    tradingAccountOptions,
    query,
    search,
    setSearch,
    clearSearch,
  }
}
